export const MenuData = [
    {
        id: 1,
        img: "https://cdn01.pharmeasy.in/dam/discovery/categoryImages/6d462f424a43372ea8b7b6f8ca13e052.png",
        catagory: "Covid Essentials",
        offer: 77
    },
    {
        id: 2,
        img: "https://cdn01.pharmeasy.in/dam/discovery/categoryImages/9f446c0e74273d70b0baf85e4ff0f76a.png",
        catagory: "Personal Care",
        offer: 80
    },
    {
        id: 3,
        img: "https://cdn01.pharmeasy.in/dam/discovery/categoryImages/aace6d1f0dc03f1f8c6e26dd880e1934.png",
        catagory: "Health Food and Drinks",
        offer: 57
    },
    {
        id: 4,
        img: "https://cdn01.pharmeasy.in/dam/discovery/categoryImages/3c7ab4d29c6631f7a5cb7eafd3bfbc79.png",
        catagory: "Beauty",
        offer: 35
    },
    {
        id: 5,
        img: "https://cdn01.pharmeasy.in/dam/discovery/categoryImages/9b3ad6971475304e9e1614ac30d4545a.png",
        catagory: "Skin Care",
        offer: 50
    },
    {
        id: 6,
        img: "https://cdn01.pharmeasy.in/dam/discovery/categoryImages/dc96175686f135b5a22d1e57165d0246.png",
        catagory: "Home Care",
        offer: 35
    },
    {
        id: 7,
        img: "https://cdn01.pharmeasy.in/dam/discovery/categoryImages/ecad9a974e003fb987858b3ee81413c6.png",
        catagory: "Ayurvedic Care",
        offer: 70
    },
    {
        id: 8,
        img: "https://cdn01.pharmeasy.in/dam/discovery/categoryImages/f970ef9868093acb9d1d37a9387912f9.png",
        catagory: "Sexual Wellness",
        offer: 53
    },
    {
        id: 9,
        img: "https://cdn01.pharmeasy.in/dam/discovery/categoryImages/9cf0c849550a38109738815b3fc2fac6.png",
        catagory: "Fitness Suplements",
        offer: 80
    },
    {
        id: 10,
        img: "https://cdn01.pharmeasy.in/dam/discovery/categoryImages/efdbfba5bfbb3b809728b627e7dfa118.png",
        catagory: "Mother and Baby Care",
        offer: 50
    },
    {
        id: 11,
        img: "https://cdn01.pharmeasy.in/dam/discovery/categoryImages/ac80578390a23bcfb1ed5a4551886ea7.png",
        catagory: "Healthcare Devices",
        offer: 65
    },
    {
        id: 12,
        img: "https://cdn01.pharmeasy.in/dam/discovery/categoryImages/e0863336e309387bb5bdf0b8e1d314e4.png",
        catagory: "Health Conditon",
        offer: 65
    },
    {
        id: 13,
        img: "https://cdn01.pharmeasy.in/dam/discovery/categoryImages/c3cfab4f38b63297b4096607e1349d61.png",
        catagory: "Diabetic Care",
        offer: 65
    },
    {
        id: 14,
        img: "https://cdn01.pharmeasy.in/dam/discovery/categoryImages/4eb8bfa2d4ea3bc0a5cade3b15aa246e.png",
        catagory: "Elderly Care",
        offer: 45
    },
    {
        id: 15,
        img: "https://cdn01.pharmeasy.in/dam/discovery/categoryImages/1a830431aa043c9caef5a8f37cfb4b06.png",
        catagory: "Accessories and Wearables",
        offer: 35
    },
    {
        id: 16,
        img: "https://cdn01.pharmeasy.in/dam/discovery/categoryImages/f10917087a483040b557e4b18204312c.png",
        catagory: "Top Products",
        offer: 10
    },
]